/* eslint-disable @typescript-eslint/no-explicit-any */
import { pickDataProps } from '../../utils/pick-data-props.js';
import { pickA11yProps } from '../../utils/pick-a11y-props.js';
import {} from '@oneaudi/unified-web-alpha-common';
import { forwardRef } from 'react';
import React from 'react';
import { StyledButton } from './index.styles.js';
import { Icon } from '../icon/index.js';
import {} from '../icon/icon-names.generated.js';
export const hasHref = (props) => {
    return typeof props.href === 'string';
};
export const ComponentButton = forwardRef((props, ref) => {
    const { margin, className } = props;
    const icon = React.createElement(Icon, { name: props.icon, size: "xs" });
    const baseProps = {
        $margin: margin,
        className,
        ref,
        ...pickA11yProps(props),
        ...pickDataProps(props),
        'aria-label': props['aria-label']
    };
    if (hasHref(props)) {
        const { href, target, rel, onClick, onKeyDown } = props;
        return (React.createElement(StyledButton, { as: "a", ...baseProps, href: href, target: target, rel: rel, onClick: onClick, onKeyDown: onKeyDown }, icon));
    }
    const { onClick, onKeyDown, type, disabled } = props;
    return (React.createElement(StyledButton, { as: "button", ...baseProps, onClick: onClick, onKeyDown: onKeyDown, type: type, disabled: disabled }, icon));
});
ComponentButton.displayName = 'ComponentButton';
//# sourceMappingURL=index.js.map